<template>
	<Alert>
		<template #icon>
			<IconCogTooth />
		</template>
		<slot />
	</Alert>
</template>

<script>
import Alert from './Alert.vue'
import IconCogTooth from '../icon/IconCogTooth.vue'
import AlertMixin from './AlertMixin.js'
export default {
	mixins: [AlertMixin],
	components: {
		Alert,
		IconCogTooth
	}
}
</script>
